<template>
  <v-container v-if="showData" fluid class="bg-background ma-0 pa-4">
  </v-container>
  <v-container v-else fluid class="bg-background ma-0 pa-4">
    <div>
      <v-row class="ma-0 pa-0 pb-2" align="center">
        <v-btn
          class="ma-0 mr-2"
          color="secondary"
          size="x-small"
          @click="back"
          v-if="combinedReportView === 'singleReportView'"
          icon="mdi-chevron-left"
        >
        </v-btn>
        <v-col class="ma-0 pa-2">
          <v-icon
            v-if="combinedReportView === 'reportList'"
            icon="mdi-chart-box-outline"
            color="primary"
            class="ml-2"
          ></v-icon>
          <span :class="combinedReportView !== 'reportList' || 'ml-2'"
            >Combined Test Reports</span
          >
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-container fluid class="mt-8 ma-0 pa-0 mr-5">
        <div>
          <div v-if="combinedReportView === 'reportList'">
            <div
              class="div-center t-h5Reg"
              v-if="combinedTestReports.length === 0"
            >
              <v-row class="align-center" justify="center">
                <v-col cols="12">
                  <v-container>
                    {{ `No reports available!` }}
                  </v-container>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row
                class="mx-3"
                v-for="item in combinedTestReports"
                :key="item.reportId"
              >
                <v-col cols="12">
                  <v-hover v-slot="{ isHovering, props }">
                    <v-card
                      elevation="0"
                      :class="{ 'on-hover': isHovering }"
                      class="pa-1 combined-report-card"
                      v-bind="props"
                    >
                      <v-card-item class="pb-0">
                        <v-card-title class="card-title ma-0 p-0 t-h6">
                          <v-row class="align-center ma-0 pa-0">
                            {{ item.name }}
                          </v-row>
                        </v-card-title>
                      </v-card-item>

                      <v-card-text class="t-subtitle-2">
                        <v-row class="align-center ma-0 pa-0 pt-1">
                          <span class=""
                            >{{ userTestCollectionsMapping[item.collectionId] }}
                          </span>
                        </v-row>
                        <v-row dense class="align-center">
                          <v-col cols="10">
                            <span class="font-weight-black"
                              >Cumualtive Report For Tests:&nbsp;
                            </span>
                            <span>
                              {{ item.tests.map(t => t.name).join(", ") }}
                            </span>
                          </v-col>
                          <v-col cols="2" dense class="align-center">
                            <v-btn
                              class="btn-rd t-btn text-capitalize"
                              rounded
                              @click="viewCombinedTestReport(item)"
                              elevation="0"
                              color="secondary"
                            >
                              View Report
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else-if="combinedReportView === 'singleReportView'">
            <CombinedReportPage :report="currentCombinedTestReport" />
          </div>
        </div>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import CombinedReportPage from "../Test/CombinedTestReportPages/CombinedReportPage.vue";
import {
  AnalyticsEvents,
  recordAnalyticsEvent
} from "@/services/awsPinpointAnalyticsService";
export default {
  name: "CombinedReportsPage",
  components: {
    CombinedReportPage
  },
  data: () => ({
    currentCombinedTestReport: {},
    combinedReportView: "reportList",
    showData: false
  }),
  watch: {},
  async created() {
    recordAnalyticsEvent(AnalyticsEvents.v2CombinedTestsReportPageOpened);
    this.$store.commit("loading", true);
    this.showData = true;
    await this.getCollectionsFromServer();
    await this.getCombinedReportsFromServer();
    this.$store.commit("loading", false);
    this.showData = false;
  },
  computed: {
    userTestCollectionsMapping: {
      get() {
        let data = this.$store.state.userTestCollections;
        let collectionMapping = {};

        data.forEach(item => {
          collectionMapping[item.collectionId] = item.collectionName;
        });
        console.log(collectionMapping);
        return collectionMapping;
      },
      set() {
        return {};
      }
    },
    combinedTestReports: {
      get() {
        let data = this.$store.state.combinedTestReports;
        return data;
      }
    }
  },
  methods: {
    async getCollectionsFromServer() {
      await this.$store.dispatch("loadUserTestCollections", {});
    },
    viewCombinedTestReport(item) {
      this.currentCombinedTestReport = item;
      this.$store
        .dispatch("getStudentCombinedTestReport", item.reportId)
        .then(() => {
          //console.log("in the file Test List", res);
          this.combinedReportView = "singleReportView";
        });
      recordAnalyticsEvent(AnalyticsEvents.v2CombinedTestReportView, {
        reportName: item.name,
        reportId: item.reportId
      });
    },
    async getCombinedReportsFromServer() {
      await this.$store.dispatch("loadCombinedTestReports", {}).then(() => {
        //console.log(res);
      });
    },
    back() {
      //console.log("combinedReportView", this.combinedReportView);
      if (this.combinedReportView === "singleReportView") {
        this.combinedReportView = "reportList";
        return;
      }
    }
  }
};
</script>

<style>
.v-card.on-hover {
  /* border: 1px solid rgb(var(--v-theme-primary)); */
  border-color: transparent;
  background-color: white;
  box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important;
}

.combined-report-card {
  box-shadow: 0px 2px 16px rgba(15, 27, 38, 0.1);
  border-radius: 5px;
  background-color: rgb(var(--v-theme-navColor));
  border: 1px solid #ededed;
}

.card-title {
  padding-bottom: 0px !important;
}
.div-center {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100vw;
  text-align: center;
}
</style>
